"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var BrandImageContentList_1 = require("./dlgSelectBrandImage/BrandImageContentList");
var DlgSelectBrandImage = /** @class */ (function (_super) {
    __extends(DlgSelectBrandImage, _super);
    function DlgSelectBrandImage(props) {
        return _super.call(this, props) || this;
    }
    DlgSelectBrandImage.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.dialogTitle,
            });
        });
        this.setState({
            visible: false,
            dialogTitle: ""
        });
    };
    DlgSelectBrandImage.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgSelectBrandImage.prototype.isDataValid = function () {
        return true;
    };
    DlgSelectBrandImage.prototype.handleSelect = function (brandId, dirName, fileName) {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onSelect) {
                this.props.controller.DATA.onSelect(brandId, dirName, fileName);
            }
        }
    };
    DlgSelectBrandImage.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgSelectBrandImage.prototype.handleYes = function () {
        this.props.controller.Close();
    };
    DlgSelectBrandImage.prototype.render = function () {
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), 
            // okText="ВЫБРАТЬ"
            // cancelText="ЗАКРЫТЬ"
            closable: true, maskClosable: false, 
            //okType={"primary"}
            //style={{ minWidth: 500, width: 600, height: 600 }}
            // okButtonProps={{disabled: true, type : "primary"}}
            // cancelButtonProps={{type : "danger"}}
            width: 770, footer: null, zIndex: 20020 },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(BrandImageContentList_1.default, { ctxData: this.props.ctxData, onSelectImage: this.handleSelect.bind(this) })));
    };
    return DlgSelectBrandImage;
}(React.Component));
exports.default = DlgSelectBrandImage;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgSelectBrandImage.tsx
// module id = 2389
// module chunks = 0